import { useEffect, useState } from 'react';
import styled from 'styled-components';
import iconMedal from '@assets/images/icon/icon-medal.png';
import { classic } from '~/themes';
import { StoredTheme } from '~/gql/theme/theme';
import { SSpanTitle } from '~/components/styles/styles';
import { useLingui } from '@lingui/react';
import { renderFullPath } from '~/utils/common/utils';

type IProps = {
  themes: StoredTheme[];
  selectedMedals: string[];
  onSelect: (name: string) => void;
};

type TProps = IProps;

export function MedalChoice({ selectedMedals, onSelect, themes }: TProps) {
  const [availableMedals, setAvailableMedals] = useState<StoredTheme[]>([]);
  const { i18n } = useLingui();
  const [hoveredMedal, setHoveredMedal] = useState<string>('');

  useEffect(() => {
    mappedMedals(themes);
  }, [selectedMedals]);

  function mappedMedals(allThemes: StoredTheme[]) {
    const newThemes: StoredTheme[] = [];
    for (const t of allThemes) {
      if (!selectedMedals.includes(t.id)) {
        newThemes.push(t);
      }
    }
    setAvailableMedals(newThemes);
  }

  function handleSelectItem(name: string) {
    onSelect(name);
  }

  return (
    <Container>
      <SDivWrapper>
        <SDivText>
          <SSpan $color={classic.token?.colorWhite}>
            {i18n._('battle.badge.choice.text')}
          </SSpan>
        </SDivText>

        <SDivMedals>
          {availableMedals.map((medal, ind) => (
            <SDivMedalItem
              key={ind}
              onClick={() => handleSelectItem(medal.name)}
              onMouseEnter={() => setHoveredMedal(medal.name)}
              onMouseLeave={() => setHoveredMedal('')}
            >
              <SImgMedal src={iconMedal} alt="" />
              <SImgLogo src={renderFullPath(medal.fileName)} alt="" />
            </SDivMedalItem>
          ))}
        </SDivMedals>

        <SSpan $marginBottom="0" $color={classic.token?.colorWhite}>
          {hoveredMedal || i18n._('battle.badge.choice')}
        </SSpan>
      </SDivWrapper>
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  height: 100%;
  width: 100%;
  position: relative;
`;
const SDivMedals = styled.div`
  display: flex;
  justify-content: center;
  width: 80%;
`;

const SSpan = styled(SSpanTitle)`
  text-align: center;

  @media screen and (max-height: 600px) {
    font-size: 1.2rem;
  }
  @media screen and (max-height: 450px) {
    font-size: 1.1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`;

const SDivText = styled.div`
  width: 55%;
  @media screen and (max-width: 600px) {
    width: 75%;
  }
`;
const SDivWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  height: 80%;
  width: 100%;
`;

const SDivMedalItem = styled.div`
  width: 20%;
  position: relative;
`;

const SImgMedal = styled.img`
  height: auto;
  width: 100%;
`;

const SImgLogo = styled.img`
  position: absolute;
  top: 15%;
  object-fit: contain;
  left: 50%;
  height: auto;
  transform: translateX(-50%);
  width: 40%;
`;
